import styled from 'styled-components';
import {
  DialogContent as MaterialDialogContent,
} from '@material-ui/core';
import MaterialDialog from '@material-ui/core/Dialog';
import MaterialDialogActions from '@material-ui/core/DialogActions';
import { Button as MaterialButton } from '@material-ui/core';
import { GetApp as MaterialAddBox } from '@styled-icons/material/GetApp';
import CrudTable from '../crudTable';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Dialog = styled(MaterialDialog)``;

export const DialogActions = styled(MaterialDialogActions)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const DialogContent = styled(MaterialDialogContent)`
  margin: 0px !important;
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const SubmitButton = styled(MaterialButton)`
  width: 15%;
  color: #ffffff !important;
`;

export const StyledCrudTable = styled(CrudTable)`
  margin-top: 10px;
  margin-bottom: 5px;
  width: 90%;
`;

export const AddBox = styled(MaterialAddBox)`
  width: 20px;
  height: 20px;
  fill: #808080;
`;
